<script>
export default {
    name: 'NotFoundView',
}
</script>

<template>
    <b-container class="ps-missing">
        <h1 class="ps-display mb-4">Nothing here</h1>
        <p class="ps-lede mb-4">This page doesn’t exist. Everything about PolySigma is on the home page.</p>
        <b-button :to="{ name: 'home' }" variant="primary" size="lg">Go to the home page</b-button>
    </b-container>
</template>

<style scoped lang="scss">
.ps-missing {
    padding-top: clamp(3rem, 10vw, 7rem);
    padding-bottom: clamp(4rem, 10vw, 7rem);
}
</style>
